import type { MenuItem } from '../schemas/menuItemSchema';
import { isCurrentLocation } from './isCurrentLocation';

export const findSelectedPath = (items: MenuItem[]): string => {
  for (const item of items) {
    if (isCurrentLocation(item.url)) {
      return item.itemPath;
    }

    if (item.subItems.length) {
      const selectedPath = findSelectedPath(item.subItems);

      if (selectedPath) {
        return selectedPath;
      }
    }
  }

  return '';
};
